import { render, staticRenderFns } from "./retrieve.vue?vue&type=template&id=65401568&scoped=true"
import script from "./retrieve.vue?vue&type=script&lang=js"
export * from "./retrieve.vue?vue&type=script&lang=js"
import style0 from "./retrieve.vue?vue&type=style&index=0&id=65401568&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/page/retrieve.less?vue&type=style&index=1&id=65401568&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65401568",
  null
  
)

export default component.exports